module.exports = __webpack_public_path__ + "img/宣威市云峰医院.32146b0d.png";